import React, { useEffect } from 'react';
import Header from './Header';

export default function Layout({ children, projectTitle, reviewTitle, projectId }) {
    useEffect(() => {
        // Optional: Scroll to top on route change
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-background text-foreground animate-in fade-in duration-500">
            <Header projectTitle={projectTitle} reviewTitle={reviewTitle} projectId={projectId} />
            <main className="max-w-[1400px] mx-auto px-6 pb-12">
                {children}
            </main>
        </div>
    );
}
